<section class="relative lg:py-24 py-16">


  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center">
        <h3 class="mb-4 md:text-[26px] md:leading-normal text-2xl leading-normal font-semibold">Onze praktijken</h3>
    </div><!--end grid-->

    <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
        <app-vestiging-card *ngFor="let vestiging of vestigingen" [vestiging]="vestiging" [details]="true"></app-vestiging-card>
    </div><!--end grid-->
  </div><!--end container-->

  <div class="container mt-12">
      <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
          <div class="lg:col-span-7 md:col-span-6">
              <img src="assets/images/svg/contact.svg" alt="">
          </div>

          <div class="lg:col-span-5 md:col-span-6">
              <div class="lg:ml-5">
                  <div class="bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700 p-6">
                      <h3 class="mb-6 text-2xl leading-normal font-semibold">Contacteer ons !</h3>

                      <div class="lg:col-span-12 mb-3" *ngIf="mailSent">
                          <h3>Uw e-mail werd verzonden.</h3>
                      </div>

                      <form name="myForm" id="myForm" *ngIf="!mailSent">
                          <div class="grid lg:grid-cols-12 lg:gap-3">
                              <div class="lg:col-span-12 mb-3">
                                  <label for="name-reporter" class="font-semibold">Naam aanmelder:</label>
                                  <input [disabled]="disableInputs" required="true" aria-required="true" [(ngModel)]="email.naam_aanmelder" name="name-reporter" id="name-reporter" type="text" class="form-input mt-2" placeholder="Voor- en achternaam">
                              </div>

                              <div class="lg:col-span-12 mb-3">
                                  <label for="name-child" class="font-semibold">Naam kind:</label>
                                  <input [disabled]="disableInputs" required="true" aria-required="true" [(ngModel)]="email.naam_kind" name="name-child" id="name-child" type="text" class="form-input mt-2" placeholder="Voor- en achternaam">
                              </div>

                              <div class="lg:col-span-12 mb-3">
                                <label for="email" class="font-semibold">E-mailadres:</label>
                                <input [disabled]="disableInputs" required [(ngModel)]="email.email" name="email" id="email" type="email" class="form-input mt-2" placeholder="E-mail">
                              </div>

                              <div class="lg:col-span-12 mb-3">
                                  <label for="address" class="font-semibold">Woonplaats:</label>
                                  <input [disabled]="disableInputs" required="true" aria-required="true" [(ngModel)]="email.woonplaats" name="address" id="address" type="text" class="form-input mt-2" placeholder="Straatnaam, nummer en gemeente">
                              </div>

                              <div class="lg:col-span-6 mb-3">
                                <label for="phone" class="font-semibold">Telefoonnnummer:</label>
                                <input [disabled]="disableInputs" required [(ngModel)]="email.telefoon" name="phone" id="phone" type="phone" class="form-input mt-2" placeholder="Telefoon">
                              </div>

                              <div class="lg:col-span-6 mb-3">
                                <label for="birthday" class="font-semibold">Geboortedatum kind:</label>
                                <input [disabled]="disableInputs" required [(ngModel)]="email.geboortedatum" name="birthday" id="birthday" type="date" class="form-input mt-2" placeholder="Geboortedatum">
                              </div>

                              <div class="lg:col-span-6 mb-3">
                                <label for="school" class="font-semibold">School:</label>
                                <input [disabled]="disableInputs" required [(ngModel)]="email.school" name="school" id="school" type="text" class="form-input mt-2" placeholder="School">
                              </div>

                              <div class="lg:col-span-6 mb-3">
                                <label for="mutualiteit" class="font-semibold">Mutualiteit:</label>
                                <input [disabled]="disableInputs" required [(ngModel)]="email.mutualiteit" name="mutualiteit" id="mutualiteit" type="text" class="form-input mt-2" placeholder="Mutualiteit">
                              </div>

                              <div class="lg:col-span-12 mb-3">
                                <label for="discipline" class="font-semibold">Welke soort begeleiding zoekt u?</label>
                                <select [disabled]="disableInputs" required name="discipline" id="discipline" [(ngModel)]="email.discipline" class="form-input show-select-arrow mt-2" aria-label="Discipline select" placeholder="Selecteren">
                                  <option value="" disabled selected>Selecteren</option>
                                  <option *ngFor="let disc of disciplines" [value]="disc.naam.toLowerCase()">{{disc.naam}}</option>
                                </select>
                              </div>

                              <div class="lg:col-span-12 mb-3">
                                <label for="vestiging" class="font-semibold">Welke vestiging wilt u hiervoor contacteren?</label>
                                <select [disabled]="disableInputs || !email.discipline" (change)="onChange()" required name="vestiging" id="vestiging" [(ngModel)]="email.vestiging" class="form-input show-select-arrow mt-2" aria-label="Vestiging select" placeholder="Selecteren">
                                  <option value="" disabled selected>Selecteren</option>
                                  <option *ngFor="let vest of vestigingPerDiscipline[email.discipline]" [value]="vest.naam.toLowerCase()">{{vest.naam}}</option>
                                </select>
                              </div>
                          </div>

                          <div class="grid grid-cols-1 mt-3">
                              <div>
                                  <label for="comments" class="font-semibold">Jouw bericht:</label>
                                  <textarea [disabled]="disableInputs" required [(ngModel)]="email.bericht" name="comments" id="comments" class="form-input mt-2 textarea" placeholder="Typ hier je bericht aan ons."></textarea>
                              </div>
                          </div>

                          <div class="grid grid-cols-1 mt-3">
                            <p><a href='/privacy' target="_blank" class="underline text-earth-dark hover:text-earth-xdark">Lees hier hoe we jouw privacy beschermen.</a></p>
                            <div>
                              <input [disabled]="disableInputs" type="checkbox" [(ngModel)]="privacyCheckbox" required name="privacy" id="privacy" class="m-2 w-4 h-4 bg-gray-100 text-earth-dark rounded focus:ring-earth-dark" />
                              <label for="privacy">Ik ga akkoord met de manier waarop MUDICO mijn data verwerkt.</label>
                            </div>
                          </div>

                          <p class="my-2 text-red-400 font-bold animate-fade" id="error-msg" *ngIf="errormsg">{{errormsg}}</p>

                          <input [disabled]="disableInputs" (click)="sendEmail($event)" type="submit" id="submit" name="send" class="btn bg-earth-try hover:bg-earth-dark border-earth-common hover:border-black/70 text-black/70 hover:text-black/70 rounded-md mt-3" value="Versturen" />
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div><!--end container-->

</section>
